// // import React from 'react';

// // const LoginPage = () => {
// //   const backgroundImage = `${process.env.PUBLIC_URL}/uploads/media-12305327725e049caa750d0.jpg`;
// //   const logoImage = `${process.env.PUBLIC_URL}/uploads/media-13067443605e049cf2882b1.png`;

// //   return (
// //     <div
// //       className="lgn-background"
// //       style={{
// //         backgroundImage: `url(${backgroundImage})`,
// //       }}
// //     >
// //       <div className="lgn-wrapper">
// //         <div className="lgn-logo text-center">
// //           <a href="index.html">
// //             <img src={logoImage} alt="Klinikal Hospital" />
// //           </a>
// //         </div>
// //         <div className="lgn-title">Sign In</div>
// //         <div className="lgn-form">
// //           <form className="form-vertical">
// //             <input
// //               type="hidden"
// //               name="_token"
// //               defaultValue="a37c23e576049c2e86e5b09056b820f5a205da8c448f38e15ab09d2fa1edf3b588681a537df8abc56c1ff242dbef8129443905deb043c1d1166301b083bf52e8"
// //             />
// //             <div className="lgn-input form-group">
// //               <label className="control-label">Username</label>
// //               <input
// //                 className="form-control"
// //                 type="text"
// //                 name="username"
// //                 id="lgn-mail"
// //                 placeholder="Enter your Username"
// //                 autoComplete="off"
// //                 required
// //               />
// //             </div>
// //             <div className="lgn-input form-group">
// //               <label className="control-label">Password</label>
// //               <input
// //                 type="password"
// //                 name="password"
// //                 id="lgn-pass"
// //                 className="form-control"
// //                 placeholder="Enter your Password"
// //                 autoComplete="off"
// //                 required
// //               />
// //               <div className="lgn-forgot text-right">
// //                 <a
// //                   href="index313a.html?route=forgotpassword"
// //                   className="text-primary"
// //                 >
// //                   Forgot Password?
// //                 </a>
// //               </div>
// //             </div>
// //             <div className="lgn-input form-group">
// //               <label className="control-label">What is 3 plus 10 =</label>
// //               <input
// //                 type="text"
// //                 id="lgn-bot"
// //                 className="form-control"
// //                 placeholder="Answer"
// //                 autoComplete="off"
// //                 required
// //               />
// //             </div>
// //             <div className="lgn-submit text-center">
// //               <button id="lgn-submit" className="btn btn-primary" name="login">
// //                 Login
// //               </button>
// //             </div>
// //           </form>
// //         </div>

// //         <div className="pl-3 pr-3 pb-5 text-center login-autocomplete">
// //           <p>Please click on these buttons for autofill credentials.</p>
// //           <div className="btn-group pb-2">
// //             <button className="btn btn-primary btn-sm" data-username="admin" data-password="Test@123">Admin</button>
// //             <button className="btn btn-success btn-sm" data-username="sheldon" data-password="Test@123">Dean</button>
// //             <button className="btn btn-danger btn-sm" data-username="daniel" data-password="Test@123">Doctor</button>
// //             <button className="btn btn-warning btn-sm" data-username="penny" data-password="Test@123">Nurse</button>
// //             <button className="btn btn-info btn-sm" data-username="koothrappali" data-password="Test@123">Accountant</button>
// //           </div>
// //           <div className="btn-group">
// //             <button className="btn btn-secondary btn-sm" data-username="walter" data-password="Test@123">Pharmacist</button>
// //             <button className="btn btn-white btn-sm" data-username="donna" data-password="Test@123">Receptionist</button>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default LoginPage;


// import React, { useState } from 'react';
// import axios from 'axios';
// import { API } from '../../Constant/constants';

// const LoginPage = () => {
//   const backgroundImage = `${process.env.PUBLIC_URL}/uploads/media-12305327725e049caa750d0.jpg`;
//   const logoImage = `${process.env.PUBLIC_URL}/uploads/media-13067443605e049cf2882b1.png`;

//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [captchaAnswer, setCaptchaAnswer] = useState('');

//   const handleLogin = async (e) => {
//     e.preventDefault();

//     if (captchaAnswer.trim() !== '13') {
//       alert('Wrong answer to captcha!');
//       return;
//     }

//     try {
//       const response = await axios.post(`${API}/api/v1/auth/login`, {
//         email,
//         password
//       });

//       const { user, token } = response.data;
//       console.log('Login successful:', user);

//       localStorage.setItem('authToken', token);
//       localStorage.setItem('userInfo', JSON.stringify(user));

//       // Redirect to role-based dashboard
//       const roles = user.roles?.map(role => role.name);

//       if (roles.includes('DOCTOR')) {
//         window.location.href = '/doctor/home';
//       } else if (roles.includes('RECEPTIONIST')) {
//         window.location.href = '/receptionist/home'; // ✅ corrected here
//       } else if (roles.includes('ADMIN')) {
//         window.location.href = '/admin/home';
//       } else {
//         window.location.href = '/'; // fallback
//       }

//     } catch (err) {
//       console.error('Login failed:', err);
//       alert('Login failed. Check credentials.');
//     }
//   };

//   return (
//     <div
//       className="lgn-background"
//       style={{ backgroundImage: `url(${backgroundImage})` }}
//     >
//       <div className="lgn-wrapper">
//         <div className="lgn-logo text-center">
//           <a href="/">
//             <img src={logoImage} alt="Klinikal Hospital" />
//           </a>
//         </div>
//         <div className="lgn-title">Sign In</div>
//         <div className="lgn-form">
//           <form className="form-vertical" onSubmit={handleLogin}>
//             <div className="lgn-input form-group">
//               <label className="control-label">Email</label>
//               <input
//                 className="form-control"
//                 type="email"
//                 name="email"
//                 placeholder="Enter your Email"
//                 autoComplete="off"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 required
//               />
//             </div>
//             <div className="lgn-input form-group">
//               <label className="control-label">Password</label>
//               <input
//                 type="password"
//                 name="password"
//                 className="form-control"
//                 placeholder="Enter your Password"
//                 autoComplete="off"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 required
//               />
//               <div className="lgn-forgot text-right">
//                 <a href="#" className="text-primary">Forgot Password?</a>
//               </div>
//             </div>
//             <div className="lgn-input form-group">
//               <label className="control-label">What is 3 plus 10 =</label>
//               <input
//                 type="text"
//                 className="form-control"
//                 placeholder="Answer"
//                 autoComplete="off"
//                 value={captchaAnswer}
//                 onChange={(e) => setCaptchaAnswer(e.target.value)}
//                 required
//               />
//             </div>
//             <div className="lgn-submit text-center">
//               <button id="lgn-submit" className="btn btn-primary" type="submit">
//                 Login
//               </button>
//             </div>
//           </form>
//         </div>

//         <div className="pl-3 pr-3 pb-5 text-center login-autocomplete">
//           <p>Please click on these buttons for autofill credentials.</p>
//           <div className="btn-group pb-2">
//             <button
//               className="btn btn-primary btn-sm"
//               onClick={() => {
//                 setEmail('admin@example.com');
//                 setPassword('Test@123');
//               }}
//             >
//               Admin
//             </button>
//             <button
//               className="btn btn-success btn-sm"
//               onClick={() => {
//                 setEmail('sheldon@example.com');
//                 setPassword('Test@123');
//               }}
//             >
//               Dean
//             </button>
//             <button
//               className="btn btn-danger btn-sm"
//               onClick={() => {
//                 setEmail('daniel@example.com');
//                 setPassword('Test@123');
//               }}
//             >
//               Doctor
//             </button>
//             <button
//               className="btn btn-warning btn-sm"
//               onClick={() => {
//                 setEmail('penny@example.com');
//                 setPassword('Test@123');
//               }}
//             >
//               Nurse
//             </button>
//             <button
//               className="btn btn-info btn-sm"
//               onClick={() => {
//                 setEmail('koothrappali@example.com');
//                 setPassword('Test@123');
//               }}
//             >
//               Accountant
//             </button>
//           </div>
//           <div className="btn-group">
//             <button
//               className="btn btn-secondary btn-sm"
//               onClick={() => {
//                 setEmail('walter@example.com');
//                 setPassword('Test@123');
//               }}
//             >
//               Pharmacist
//             </button>
//             <button
//               className="btn btn-white btn-sm"
//               onClick={() => {
//                 setEmail('donna@example.com');
//                 setPassword('Test@123');
//               }}
//             >
//               Receptionist
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoginPage;

import React, { useState } from 'react';
import axios from 'axios';
import { API } from '../../Constant/constants';
import Logo from "../../assets/img/hph-logo.png"

const LoginPage = () => {
  const backgroundImage = `${process.env.PUBLIC_URL}/uploads/media-12305327725e049caa750d0.jpg`;
  const logoImage = `${process.env.PUBLIC_URL}/uploads/media-13067443605e049cf2882b1.png`;

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [captchaAnswer, setCaptchaAnswer] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();

    if (captchaAnswer.trim() !== '13') {
      alert('Wrong answer to captcha!');
      return;
    }

    try {
      const response = await axios.post(`${API}/api/v1/auth/login`, {
        email,
        password,
      });

      const { user, token } = response.data;

      // Save login state
      localStorage.setItem('user', JSON.stringify(user));  // ✅ key must be 'user'
      localStorage.setItem('authToken', token);


      // Role-based redirect
      const roles = user.roles?.map(r => r.name) || [];

      if (roles.includes('ADMIN')) {
        window.location.href = '/admin/home';
      } else if (roles.includes('DOCTOR')) {
        window.location.href = '/doctor/home';
      } else if (roles.includes('RECEPTIONIST')) {
        window.location.href = '/receptionist/home';
      } else {
        alert('Unauthorized role. Please contact administrator.');
        return;
      }
    } catch (err) {
      console.error('Login error:', err);
      alert('Login failed. Check your credentials.');
    }
  };

  return (
    <div className="lgn-background" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="lgn-wrapper">
        <div className="lgn-logo text-center">
          <a href="/">
            <img src={Logo} alt="Klinikal Hospital" />
          </a>
        </div>
        <div className="lgn-title">Sign In</div>
        <div className="lgn-form">
          <form onSubmit={handleLogin}>
            <div className="lgn-input form-group">
              <label>Email</label>
              <input
                className="form-control"
                type="email"
                placeholder="Enter your Email"
                autoComplete="off"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="lgn-input form-group">
              <label>Password</label>
              <input
                type="password"
                className="form-control"
                placeholder="Enter your Password"
                autoComplete="off"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
              />
              <div className="lgn-forgot text-right">
                <a href="#" className="text-primary">Forgot Password?</a>
              </div>
            </div>
            <div className="lgn-input form-group">
              <label>What is 3 plus 10 =</label>
              <input
                type="text"
                className="form-control"
                placeholder="Answer"
                autoComplete="off"
                value={captchaAnswer}
                onChange={e => setCaptchaAnswer(e.target.value)}
               
              />
            </div>
            <div className="lgn-submit text-center">
              <button type="submit" className="btn btn-primary">Login</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;

